export enum LocationTypeEnum {
  BUILDING = 'BUILDING',
  COMPANY = 'COMPANY',
  FLOOR = 'FLOOR',
  NO_WING = 'NO_WING',
  PARKING = 'PARKING',
  WING = 'WING',
}
